import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { environment } from 'src/environments/environment';
import {
  toODataString,
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from '@progress/kendo-data-query';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { CldrIntlService } from '@progress/kendo-angular-intl';

@Injectable({
  providedIn: 'root',
})
export class ListAssetForLeaseAgreementService extends BehaviorSubject<GridDataResult> {
  public loading: boolean;
  public tableName: string;
  public param1: Date;
  public param2: boolean;
  private BASE_URL = environment.apiUrl;
  refreshTrigger = new Subject<string>();
  importStarted = new Subject<string>();
  constructor(private http: HttpClient, private intl: CldrIntlService) {
    super(null);
  }
  refreshTable(gridName: string, param1: Date, param2: boolean) {
    this.param1 = param1;
    this.param2 = param2;
    this.refreshTrigger.next(gridName);
  }
  importTable(gridName: string) {
    this.importStarted.next(gridName);
  }
  public query(state: any): void {
    this.fetch(this.tableName, this.param1,this.param2, state).subscribe(x =>
      super.next(x)
    );
  }

  protected fetch(
    tableName: string,
    param1: Date,
    param2: boolean,
    state: any
  ): Observable<GridDataResult> {
    const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
    const hasGroups = state.group && state.group.length;
    this.loading = true;
    let url = `${this.BASE_URL}${tableName}/${encodeURIComponent(
      this.intl.formatDate(param1, 'yyyy-MM-dd')
    )}/${encodeURIComponent(param2)}?${queryStr}`;

    return this.http.get(url).pipe(
      map(
        (
          { data, total /*, aggregateResults*/ }: GridDataResult // Process the response
        ) =>
          <GridDataResult>{
            // If there are groups, convert them to a compatible format
            data: hasGroups ? translateDataSourceResultGroups(data) : data,
            total: total,
          }
      ),
      tap(() => (this.loading = false))
    );
  }
}
